import { map } from "../../../functions/HelperFuncs";

export default {
  props: { audio: String, type: String, color: String },
  data() {
    return {
      isPlaying: false,
      isUpdatingTime: false,
      sliderVal: 0,
      currentTime: "0:00",
      fullTime: "0:00",
    };
  },
  methods: {
    handlePause() {
      this.isPlaying = true;
    },

    handlePlayAudio(e) {
      e.preventDefault();
      const audioRef = this.$refs.audioElem;

      if (audioRef) {
        if (audioRef.paused || audioRef.ended) {
          //play
          this.isPlaying = true;
          audioRef.play();

          this.isUpdatingTime = false;
        } else {
          //pause
          this.isPlaying = false;

          audioRef.pause();
        }

        this.fullTime = this.setTime(audioRef.duration);
      }
    },
    handleTimeUpdate(e) {
      const elem = e.currentTarget;

      if (!isNaN(elem.currentTime) && !isNaN(elem.duration)) {
        this.sliderVal = map(elem.currentTime, 0, elem.duration, 0, 100);
      }

      this.currentTime = this.setTime(elem.currentTime);
    },

    handleStopUpdatingTime() {
      const audioRef = this.$refs.audioElem;
      this.isPlaying = true;
      audioRef.play();
    },
    handleUpdateTime(e) {
      this.isUpdatingTime = true;

      const audioRef = this.$refs.audioElem;

      if (audioRef) {
        //play
        this.isPlaying = true;
        audioRef.pause();

        audioRef.currentTime = map(
          parseInt(e.target.value),
          0,
          100,
          0,
          audioRef.duration
        );

        this.currentTime = this.setTime(audioRef.currentTime);
      }
    },

    setTime(input) {
      const value = Math.floor(input * 100) / 100;

      const m = Math.floor((input % 3600) / 60)
        .toString()
        .padStart(2, "0");
      const s = Math.floor(input % 60)
        .toString()
        .padStart(2, "0");

      return `${m}:${s}`;
    },
  },
};
